export const html: string = `<div class="bookModal" role="dialog" aria-labelledby="{{ id }}-title" aria-modal="true">
	<div class="bookModal_header">
		<h2 class="bookModal_title" id="{{ id }}-title">{{ book.title }}</h2>
		<button type="button" class="bookModal_close button -cancel -darkContainer" data-myon-on-click="handleCloseButtonClick" aria-label="{{ bookLang.ACTION_CLOSE }}">
			<i class="button_icon mycon -close "></i>
		</button>
	</div>
	<div class="bookModal_content">
		<div class="bookModal_summary">
			<div class="bookModal_cover">
				<img class="bookModal_coverImg" alt="{{ bookCoverAlt }}" data-myon-prop-src="{{ book.coverUrl }}" />
			</div>
			<div class="bookModal_language">{{ bookLang.LABEL_LANGUAGES }} {{ book.languages }}</div>
			<div class="bookModal_ratings">
				<h3 class="bookModal_ratingTitle">{{ bookLang.LABEL_AVG_RATING }}</h3>
				<div class="bookModal_rating starRating">
					<div class="starRating_rating" data-myon-attr-style="width:{{ book.avgReview | getRatingPercentage }}">
						<span class="g_screenReader">{{ book.avgReview | getRatingLang }}</span>
					</div>
				</div>
				<div data-myon-prop-hidden="{{ !showRating }}">
					<h3 class="bookModal_ratingTitle">{{ bookLang.LABEL_MY_RATING }}</h3>
					<div class="bookModal_rating starRating">
						<div class="starRating_rating" data-myon-attr-style="width:{{ book.myRating | getRatingPercentage }}">
							<span class="g_screenReader">{{ book.myRating | getRatingLang }}</span>
						</div>
					</div>
				</div>
			</div>
			<div data-myon-prop-hidden="{{ !showArQuizButton }}" class="bookModal_arButton flex -column">
				<button type="button" class="button -ar" data-myon-on-click="handleArQuizButtonClick">
					<span class="button_text">
						{{ bookLang.ACTION_AR_QUIZ }}
					</span>
				</button>
				<div class="flex -row -center">
					<table class="bookModal_table flex_item">
						<tbody>
							<tr>
								<th scope="row">{{ bookLang.LABEL_AR_POINTS }}</th>
								<td>{{ book.arPoints}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<div data-myon-prop-hidden="{{ !showGradeLevelInfo }}" class="bookModal_gradeInfo">
				<h4>{{ bookLang.HEADER_MIN_GRADE }}</h4>
				<div data-myon-prop-hidden="{{ !showLibraryManagementDisabled }}">
					{{ bookLang.DESCR_MIN_GRADE_LIBRARY_MANAGEMENT_DISABLED }}
				</div>
				<div data-myon-prop-hidden="{{ !showAdminGradeMin }}">
					<div class="bookModal_gradePopup">
						{{ bookLang.DESCR_MIN_GRADE }}
					</div>
					<p>
						<select class="select" name="gradeMin" data-myon-name="gradeMin" data-myon-on-change="handleGradeMinChange">
							<option value="0">{{  bookLang.OPTION_ALL_GRADES  }}</option>
							<option value="1">{{ userLang.GRADE_PK }}</option>
							<option value="2">{{ userLang.GRADE_KG }}</option>
							<option value="3">{{ userLang.GRADE_FIRST }}</option>
							<option value="4">{{ userLang.GRADE_SECOND }}</option>
							<option value="5">{{ userLang.GRADE_THIRD }}</option>
							<option value="6">{{ userLang.GRADE_FOURTH }}</option>
							<option value="7">{{ userLang.GRADE_FIFTH }}</option>
							<option value="8">{{ userLang.GRADE_SIXTH }}</option>
							<option value="9">{{ userLang.GRADE_SEVENTH }}</option>
							<option value="10">{{ userLang.GRADE_EIGHTH }}</option>
							<option value="11">{{ userLang.GRADE_NINTH }}</option>
							<option value="12">{{ userLang.GRADE_TENTH }}</option>
							<option value="13">{{ userLang.GRADE_ELEVENTH }}</option>
							<option value="14">{{ userLang.GRADE_TWELFTH }}</option>
							<option value="20">{{ bookLang.OPTION_NO_ACCESS }}</option>
						</select>
					</p>
				</div>
				<div data-myon-prop-hidden="{{ !bookModificationMessage }}">
					<p>{{ bookModificationMessage? @noescape }}</p>
				</div>
				<div data-myon-prop-hidden="{{ !showAdminGradeMin }}">
					<p>{{ book.minGradeBookLastModified }}</p>
				</div>
			</div>
		</div>
		<div class="bookModal_details flex -column -gutter">
		<div data-myon-name="tabContainer" class="flex_item -grow tabset -dark">
			<button class="tabset_rocker -left" type="button"><i class="mycon -pointer-left"></i></button>
			<button class="tabset_rocker -right" type="button"><i class="mycon -pointer-right"></i></button>
				<div data-myon-name="tablist" role="tablist" class="tabset_tabs">
					<button type="button" data-myon-name="overviewButton"
						class="bookModal_tab tabset_tab -overview flex -row -center -gutter">
						<i class="bookModal_tabIcon mycon -white -view "></i>
						{{ bookLang.OVERVIEW }}
					</button>
					<button type="button" data-myon-name="detailsButton"
						class="bookModal_tab tabset_tab -details flex -row -center -gutter">
						<i class="bookModal_tabIcon mycon -white -info "></i>
						{{ bookLang.DETAILS }}
					</button>
					<button type="button" data-myon-name="reviewsButton"
						class="bookModal_tab tabset_tab -reviews flex -row -center -gutter">
						<i class="bookModal_tabIcon mycon -white -star "></i>
						{{ bookLang.ACTION_SEE_REVIEWS }}
					</button>
				</div>
					<div data-myon-name="overviewTab" class="tabset_content -hidden bookModal_tabContent -overview">
						<div data-myon-name="bookHover" data-myon-prop-hidden="{{ collapseBookDescription }}" class="bookModal_descr_hover -arrow">
							<div data-myon-name="bookDescr" class="bookModal_descr">{{ book.description | valueOrDash }}</div>
						</div>
						<div data-myon-prop-hidden="{{ !collapseBookDescription }}" class="bookModal_overflow">{{ book.description | valueOrDash }}</div>
						<table data-myon-name="modalTable" class="bookModal_table">
							<caption class="g_screenReader">{{ bookLang.HEADER_INFO }}</caption>
							<tbody>
								<tr data-myon-template="similarButtons">
									<th scope="row" style="width: auto;" id="{{ id }}-{{ $key }}-label">{{ label }}</th>
									<td id="{{ id }}-{{ $key }}-value">{{ value | valueOrDash }}</td>
									<td style="width: 10%;">
										<a data-myon-attr-class="bookModal_button -lexile button -compact {{ !href? | '-disabled' }}" data-myon-attr-href="{{ href }}" aria-labelledby="{{ id }}-{{ $key }}-more {{ id }}-{{ $key }}-label {{ id }}-{{ $key }}-value">
											<span class="g_screenReader" id="{{ id }}-{{ $key }}-more">{{ bookLang.MORE_LIKE_THIS }}</span>
											<i class="mycon -more-like"></i>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div data-myon-name="detailsTab" class="tabset_content -hidden bookModal_tabContent -details">
						<table class="bookModal_table">
							<tbody>
								<tr>
									<th scope="row" style="width:25%">{{ bookLang.LABEL_AUTHOR }}</th>
									<td style="width:75%">{{ book.author | valueOrDash }}</td>
								</tr>
								<tr>
									<th scope="row">{{ bookLang.LABEL_ILLUSTRATOR }}</th>
									<td>{{ book.illustrator | valueOrDash }}</td>
								</tr>
								<tr>
									<th scope="row">{{ bookLang.LABEL_PUBLISHER }}</th>
									<td>{{ book.bookPublisherTitle | valueOrDash }}</td>
								</tr>
								<tr>
									<th scope="row">{{ bookLang.LABEL_BOOK_SERIES }}</th>
									<td>{{ book.bookSeriesTitle | valueOrDash }}</td>
								</tr>
								<tr>
									<th scope="row">{{ bookLang.LABEL_PAGE_COUNT }}</th>
									<td>{{ book.pagecount | valueOrDash }}</td>
								</tr>
								<tr>
									<th scope="row">{{ bookLang.LABEL_AUDIO_TIME }}</th>
									<td>{{ book.audioRuntimeFriendly | valueOrDash }}</td>
								</tr>
								<tr>
									<th scope="row">{{ bookLang.LABEL_LEXILE }}</th>
									<td>{{ book.lexileLabel | valueOrDash }}</td>
								</tr>
							</tbody>
						</table>
						<table class="bookModal_table">
							<tbody>
								<tr>
									<th scope="row" style="width:25%">{{ bookLang.LABEL_ATOS }}</th>
									<td style="width:75%">{{ book.arQuizLevel | formatAtos }}</td>
								</tr>
								<tr>
									<th scope="row">{{ bookLang.LABEL_AR_POINTS }}</th>
									<td>{{ book.arPoints | valueOrDash }}</td>
								</tr>
								<tr>
									<th scope="row">{{ bookLang.LABEL_AR_QUIZ }}</th>
									<td>{{ book.arQuiz | valueOrDash }}</td>
								</tr>
								<tr>
									<th scope="row">{{ bookLang.LABEL_HAS_QUIZ }}</th>
									<td>{{ book.hasBookQuiz | hasQuiz }}</td>
								</tr>
								<tr>
									<th scope="row">{{ bookLang.LABEL_RECOMMENDED_GRADE }}</th>
									<td>{{ gradeRangeString }}</td>
								</tr>
								<tr>
									<th scope="row">{{ bookLang.LABEL_GUIDED_READING }}</th>
									<td>{{ book.guidedReadingLevel | valueOrDash }}</td>
								</tr>
								<tr>
									<th scope="row">{{ bookLang.LABEL_COPYRIGHT }}</th>
									<td>{{ book.copyright | valueOrDash }}</td>
								</tr>
								<tr>
									<th scope="row">{{ bookLang.LABEL_LANGUAGE }}</th>
									<td>{{ book.languages | valueOrDash }}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div data-myon-name="reviewsTab" class="tabset_content -hidden bookModal_tabContent -reviews">
						<div data-myon-prop-hidden="{{ !reviewsLoading }}"
							class="bookModal_review -loading">
							{{ bookLang.MESSAGE_LOADING }}
						</div>
						<div data-myon-prop-hidden="{{ reviewsLoading }}">
							<div class="bookModal_review -empty"
								data-myon-prop-hidden="{{ reviews.length }}">
								{{ bookLang.MESSAGE_NO_REVIEWS }}
							</div>
							<div class="bookModal_overflow -large -review"
								data-myon-prop-hidden="{{ !reviews.length }}">
								<div
									data-myon-attr-class="bookModal_review {{ userId | isCurrentUser? | '-yours' }}"
									data-myon-template="reviews"
									data-myon-sort="sortReviews">
									<div class="bookModal_reviewStars">
										<div class="bookModal_starRating">
											<div data-myon-attr-class="bookModal_stars -stars{{ score | toInt }}">
												<span class="g_screenReader">{{ score | getRatingLang }}</span>
											</div>
										</div>
									</div>
									<div class="bookModal_reviewBody">{{ body }}</div>
								</div>
							</div>
						</div>
					</div>
			</div>
			<div class="flex -row -gutter -center">
				<button data-myon-template="secondaryActions" type="button" class="bookModal_lowButton flex -row -centerLeft -gutter" data-myon-on-click="handleActionClick(action)">
					{{ icon @noescape }}
					<span>{{ label @noescape }}</span>
				</button>
			</div>
		</div>
	</div>
	<div class="bookModal_actions">
		<div class="bookModal_buttonGroup">
			<button data-myon-template="primaryActions" type="button" class="bookModal_button -modalAction button -scrolling {{ modifierClass? }}" data-myon-on-click="handleActionClick(action)">
				<div class="button_scrollContents">
					{{ icon @noescape }}
				</div>
				<div class="button_scrollContents">
					{{ label @noescape }}
				</div>
			</button>

		</div>
	</div>
</div>`;
